import utilObject from '@/utils/object'

export const getKeysWithFormulas = (jsonForm) => {
  return utilObject.findValues(jsonForm, 'formulas')
}

export const getConfig = (jsonForm) => {
  return configForms(jsonForm)
}

export const calc = async (mapFormulas, form) => {
  return form
}

export default {
  getKeysWithFormulas,
  getConfig
}

function configForms (forms) {
  let config = {}
  for (let f in forms.components) {
    let form = forms.components[f]
    for (let p in form.components) {
      let panel = form.components[p]
      for (let c in panel.components) {
        let tab = {label: null}
        let comp = panel.components[c]
        let preKey = (form.key ? form.key + '.' : '') + panel.key
        if (comp.components) {
          tab = comp
          let tabItem = tab.components[0]
          for (let t in tabItem.components) {
            comp = tabItem.components[t]
            const key = preKey + '.' + tab.key + '.' + tabItem.key + '.' + (comp.key || 'comp' + t)
            if (comp.type === 'table') {
              for (let r in comp.rows) {
                let row = comp.rows[r]
                const rowKey = key + '.' + row.key
                config[rowKey] = {key: rowKey, form, panel, tab, comp: {type: 'row', ...row}}
              }
            } else {
              config[key] = {key, form, panel, tab, comp}
            }
          }
        } else {
          const key = preKey + '.' + (comp.key || 'comp' + c)
          config[key] = {key, form, panel, tab, comp}
        }
      }
    }
  }
  return config
}



// WEBPACK FOOTER //
// ./src/api/formulas.js